import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Utility } from 'src/app/utils/app-utils';
import { InsightsService } from 'src/app/services/insights.service';
import { AppConfigService } from 'src/app/app-config.service';
import { Alarm } from 'src/models/alarm.model';

interface incidentsData {
  label: string;
  key: string;
  value: number;
}

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss']
})
export class IncidentsComponent implements OnInit {
  realTimeMinHeight: number = 0;
  private dateRangeSubscription: Subscription;
  @Input() selectedAlarm: Alarm;

  incidentsData: incidentsData[] = [
    {
      label: 'Acknowledged',
      key: 'handling',
      value: 0
    },
    {
      label: 'Automation',
      key: 'automation',
      value: 0
    },
    {
      label: 'Escalated',
      key: 'escalated',
      value: 0
    },
    {
      label: 'False',
      key: 'false',
      value: 0
    },
    {
      label: 'Resolved',
      key: 'resolved',
      value: 0
    },
  ];

  liveIncidentsFlipped = false;

  constructor(
    public insightsService: InsightsService,
    public appConfigService: AppConfigService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.listenToDateRangeChanges();
  }

  async getLiveAlarmsData() {
    let res = await this.insightsService.getLiveAlarms();
    if (res && res.success && res.data && res.data.results) {
      this.incidentsData.forEach(incident => {
        incident.value = res.data.results[incident.key] ?? 0;
      });
    } else {
      this.incidentsData.forEach(incident => {
        incident.value = 0;
      });
    }
  }

  listenToDateRangeChanges() {
    this.dateRangeSubscription = this.insightsService.currentDateRange.subscribe(async (dateRange) => {
      await this.getLiveAlarmsData();
    });
  }

  ngAfterViewInit() {
    this.checkScreenWidth();
    this.cdr.detectChanges();
  }

  checkScreenWidth() {    
    this.realTimeMinHeight = window.innerHeight >= 1300 ? 24
      : window.innerHeight >= 1080 ? 25
        : window.innerHeight >= 1024 ? 26.5
          : window.innerHeight == 905 ? 20
            : window.innerHeight >= 934 ? 26.5
              : window.innerHeight >= 919 ? 25
              : 27;
  }

  flipLiveIncidents() {
    this.liveIncidentsFlipped = !this.liveIncidentsFlipped;

  }

  ngOnDestroy() {
    Utility.Unsubscribe(this.dateRangeSubscription);
  }

}
